import FormConfig from "./ConfigurationFormConfig";
import AjaxUtility from "../Utility/AjaxUtility";

var geocoder;

window.initGeocoder = function() {
	geocoder = new google.maps.Geocoder();
}

export default class RainwaterSelectionMapAt {
	constructor() {
		$(FormConfig.selectors.rainwaterMapLoading).show();
		this.container = $('#weatherStationMap');
		var iconPath = this.container.data('icon-path');
		this.geoCodeErrorMsg = $('#geocodeError');
		this.rcIndexField = $(FormConfig.selectors.rcIndexInput);
		this.rcIndexOutput = $(FormConfig.selectors.rcIndexOutput);
		this.locationData = null;
		this.homeLocation = null;
		this.homeMarker = null;
		this.closestLocationMarker = null;
		this.activeMarker = null;
		this.distanceMarkers = [];
		this.propertyZipInput = $(FormConfig.selectors.propertyZipInput);
		this.propertyCityInput = $(FormConfig.selectors.propertyCityInput);
		this.propertyStreetInput = $(FormConfig.selectors.propertyStreetInput);
		this.originalGridIndexInput = $(FormConfig.selectors.originalGridIndexInput);
		this.regionInput = $(FormConfig.selectors.regionInput);

		this.show();

		this.map = L.map('weatherStationMap', {
			zoomControl: true,
			boxZoom: true,
			doubleClickZoom: true,
			dragging: true,
			scrollWheelZoom: true,
			touchZoom: true,
			maxZoom: 14,
			minZoom: 11
		}).fitBounds([[47.25620524764984, 9.538350376340047], [48.906986611234885, 17.012186347002995]]);
		this.map.zoomControl.setPosition('bottomright');
		this.map.attributionControl.setPrefix('<a href="https://www.bkg.bund.de" target="_blank">www.bkg.bund.de</a> &middot; <a href="https://github.com/tomchadwin/qgis2web" target="_blank">qgis2web</a> &middot; <a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> &middot; <a href="https://qgis.org">QGIS</a>');
		this.map.attributionControl.setPosition('bottomleft');
		var bounds_group = new L.featureGroup([]);
		this.map.createPane('pane_TopPlusOpenGraustufen_0');
		this.map.getPane('pane_TopPlusOpenGraustufen_0').style.zIndex = 400;
		var layer_TopPlusOpenGraustufen_0 = L.WMS.layer("https://sgx.geodatenzentrum.de/wms_topplus_open", "web", {
			pane: 'pane_TopPlusOpenGraustufen_0',
			format: 'image/png',
			uppercase: true,
			transparent: true,
			continuousWorld: true,
			tiled: true,
			info_format: 'text/html',
			opacity: 1,
			identify: false,
			attribution: '',
		});
		this.map.addLayer(layer_TopPlusOpenGraustufen_0);
		this.homeIcon = L.icon({
			iconUrl: iconPath + 'marker-home.png',
			shadowUrl: iconPath + 'marker-shadow.png',

			iconSize:     [60, 61], // size of the icon
			shadowSize:   [41, 41], // size of the shadow
			iconAnchor:   [30, 52], // point of the icon which will correspond to marker's location
			shadowAnchor: [12, 41],  // the same for the shadow
			popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
		});
		this.activeIcon = L.icon({
			iconUrl: iconPath + 'marker-active.png',
			shadowUrl: iconPath + 'marker-shadow.png',

			iconSize:     [61, 61], // size of the icon
			shadowSize:   [41, 41], // size of the shadow
			iconAnchor:   [30, 52], // point of the icon which will correspond to marker's location
			shadowAnchor: [12, 41],  // the same for the shadow
			popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
		});

		/*
		const abstract = new L.Control({'position': 'topright'});
		abstract.onAdd = () => {
			this.div = L.DomUtil.create('div', 'leaflet-control abstract');
			this.div.id = 'abstract'
			this.div.innerHTML = '<img src="/fileadmin/dwd-logo.png" />'
			return this.div;
		}
		abstract.addTo(this.map);
		 */

		this.map.on('layeradd', () => {
			$(FormConfig.selectors.rainwaterMapLoading).hide();
		});

		const script = document.createElement('script');
		script.async = true;
		script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYhLdncbls5waHK0XTBHzZ8YPK88aTMUk&loading=async&callback=initGeocoder";
		document.body.appendChild(script);

		this.hide();

		this.getLocationData();

		this.propertyZipInput.on('blur', () => this.getNewHomeLocation());
		this.propertyCityInput.on('blur', () => this.getNewHomeLocation());
		this.propertyStreetInput.on('blur', () => this.getNewHomeLocation());
	}

	addMoveHandler() {
		this.map.on("moveend", () => {
			const center = this.map.getCenter();
			const closestLocations = this.findClosestLocations([center.lat, center.lng], this.homeLocation);
			this.removeDistanceMarkers();
			closestLocations.forEach(location => {
				this.setDistanceMarker(location);
			});
		});
	}

	removeMoveHandler() {
		this.map.off("moveend");
	}

	getNewHomeLocation() {
		const zip = this.propertyZipInput[0].value;
		if(zip !== '' && /^[0-9]{4}$/.test(zip) && this.propertyCityInput[0].value !== '' && this.propertyStreetInput[0].value !== '') {
			this.findLocation(`${this.propertyStreetInput[0].value}, ${this.propertyZipInput[0].value} ${this.propertyCityInput[0].value}, Austria`)
		}
	}

	findLocation(address) {
		if(geocoder) {
			this.geoCodeErrorMsg.hide();
			this.removeMoveHandler();

			return geocoder.geocode({'address': address}, (results, status) => {
				if (status == 'OK') {
					if(results[0].address_components.length < 2) {
						this.geoCodeErrorMsg.show();
						return;
					}

					this.show();
					this.homeLocation = [results[0].geometry.location.lat(), results[0].geometry.location.lng()];

					if(this.homeMarker !== null) {
						this.homeMarker.removeFrom(this.map);
					}
					this.homeMarker = this.setMarker(this.homeLocation, 'home');

					const closestLocations = this.findClosestLocations(this.homeLocation);
					const bounds = this.getBounds(closestLocations);
					this.originalGridIndexInput.val(closestLocations[0].location.g);
					this.regionInput.val(this.getRegionFromGeocode(results[0]));

					this.removeDistanceMarkers();
					closestLocations.forEach((location, i) => {
						if(i === 0) {
							this.updateRcIndex(location.location.g, this.setDistanceMarker(location));
						} else {
							this.setDistanceMarker(location)
						}
					});
					this.map.fitBounds(bounds);
					this.addMoveHandler();
				} else {
					alert('Geocode was not successful for the following reason: ' + status);
				}
			})
		}
	}

	getRegionFromGeocode(geocodeResults) {
		const region = geocodeResults.address_components.find(addressComponent => addressComponent.types.includes('administrative_area_level_1'));
		if (region !== undefined) {
			return region.long_name;
		}

		return '';
	}

	setMarker(position, title) {
		if (title == 'home') {
			return L.marker(position, {icon: this.homeIcon}).addTo(this.map);
		}
		return L.marker(position, {title: title}).addTo(this.map);
	}

	setDistanceMarker(location, addToArray = true) {
		const marker = L.marker(location.location.l, {opacity: 0.6, title: location.distance.toLocaleString(undefined, {maximumFractionDigits: 2}) + ' km'}).addTo(this.map);
		marker.on('click', () => {
			this.updateRcIndex(location.location.g, marker);
		});
		if(this.activeMarker && location.location.l[0] === this.activeMarker.getLatLng().lat && location.location.l[1] === this.activeMarker.getLatLng().lng) {
			marker.setOpacity(1);
			marker.setIcon(this.activeIcon);
			this.activeMarker = marker;
		}
		if(addToArray) {
			this.distanceMarkers.push(marker);
		}
		return marker;
	}

	removeDistanceMarkers() {
		if(this.distanceMarkers.length) {
			this.distanceMarkers.forEach(marker => {
				marker.removeFrom(this.map);
			});
			this.distanceMarkers = [];
		}
	}

	updateRcIndex(rcIndex, marker) {
		if(this.activeMarker !== null) {
			this.activeMarker.setOpacity(0.6);
			this.activeMarker.setIcon(marker.getIcon());
		}

		marker.setIcon(this.activeIcon);
		marker.setOpacity(1);
		this.activeMarker = marker;
		this.rcIndexField.val(rcIndex);

		this.rcIndexOutput.parent().show();
		this.rcIndexOutput.html(rcIndex);
	}

	getLocationData() {
		this.locationData = JSON.parse(sessionStorage.getItem('locationData'));
		if(this.locationData === null) {
			AjaxUtility.request('Configurator', {
				controller: 'Configuration',
				action: 'getLocationData'
			}).done(response => {
				this.locationData = JSON.parse(response);
				sessionStorage.setItem('locationData', response);
			});
		}
	}

	findClosestLocations(location, origin = null) {
		const locations = this.locationData.reduce((carry, loc) => {
			let distance = this.calcGeographicalDistance(location, loc['l']);

			if(carry.length === 0 || carry[carry.length-1].distance > distance) {
				carry.push({
					distance: distance,
					location: loc
				});
				carry.sort((a, b) => {
					return a.distance - b.distance;
				});
				if(carry.length > 70) {
					carry.pop();
				}
			}

			return carry;
		}, []);

		// calculate distance to origin point when searching from map center
		if(origin !== null) {
			locations.forEach(loc => {
				loc.distance = this.calcGeographicalDistance(origin, loc.location['l']);
			});
		}

		return locations;
	}

	/**
	 * Calculates geographical distance between two coordinates
	 */
	calcGeographicalDistance(loc1, loc2) {
		/*
		ACOS
			(
				(
					SIN(Lat1) * SIN(Lat2)
				) +
				(
					COS(Lat1) * COS(Lat2)
				) *
				(
					COS(Lon2 - Lon1)
				)
			) * 6371
		 */
		const loc10 = this.toRadians(loc1[0]),
			loc11 = this.toRadians(loc1[1]),
			loc20 = this.toRadians(loc2[0]),
			loc21 = this.toRadians(loc2[1]);

		return Math.acos
		(
			(
				Math.sin(loc10) * Math.sin(loc20)
			) +
			(
				Math.cos(loc10) * Math.cos(loc20)
			) *
			(
				Math.cos(loc21 - loc11)
			)
		) * 6371
	}

	getBounds(locations) {
		return locations.reduce((carry, loc) => {
			if(loc.location.l[0] < carry[0][0]) {
				carry[0][0] = loc.location.l[0];
			}
			if(loc.location.l[1] < carry[0][1]) {
				carry[0][1] = loc.location.l[1];
			}
			if(loc.location.l[0] > carry[1][0]) {
				carry[1][0] = loc.location.l[0];
			}
			if(loc.location.l[1] > carry[1][1]) {
				carry[1][1] = loc.location.l[1];
			}
			return carry;
		}, [
			[9999, 9999],
			[-9999, -9999]
		])
	}

	toRadians(deg) {
		return (deg * Math.PI) / 180.0;
	}

	hide() {
		this.container.hide();
	}

	show() {
		this.container.show();
	}
}
